import React from 'react';
import './Bjservice.css'; 
import BJSeries from '../../../imgs/JE-Series.webp';
import KIISeries from '../../../imgs/JEV-Series.webp';

function Jeservice() {
  return (
    <div className="bj-container">
      <h2 className="heading"></h2>
      <div className="card-wrapper">
        <div className="card-Bjeservise" data-aos="fade-down-left">
          <img
            src={BJSeries}
            alt="BJ Series"
            className="card-image"
          />
          <p className="card-servis">JE Series- All-Electric Injection Molding Machine</p>
        </div>
        <div className="card-Bjeservise" data-aos="fade-down-right">
          <img
            src={KIISeries}
            alt="KII Series"
            className="card-image"
          />
          <p className="card-servis">JEV Series-  Hybrid Injection Molding Machine</p>
        </div>
      </div>
    </div>
  );
}

export default Jeservice;
